import './SupplyProduct.scss';
import Component from './SupplyProduct.js';
export default Component;
